export const ID_SISTEMA_RAIZ = 1
export const ID_SISTEMA_WOLIFLIX = 66
